import React from 'react';
import { 
  HeroSection, 
  ServiceSection, 
  AboutSection, 
  SpecialDishSection, 
  MenuSection, 
  TestimonialsSection, 
  ReservationSection, 
  FeaturesSection 
} from '@components/sections';

const HomePage: React.FC = () => {
  return (
    <main>
      <article>
        <HeroSection />
        <ServiceSection />
        <AboutSection />
        <SpecialDishSection />
        <MenuSection />
        <TestimonialsSection />
        <ReservationSection />
        <FeaturesSection />
      </article>
    </main>
  );
};

export default HomePage;
